import React from 'react'
import {Container, Row, Col} from 'react-bootstrap';

export const MissionAndVision = () => {
    return (
      <Container className="fablab-container" id="mision-y-vision">
        <Row>
          <Col>
            <h1 className="fablab-title">Misión y Visión</h1>			
          </Col>
        </Row>

        <Row>
          <Col xs={12} md={6}>
            <h2 className="fablab-subtitle">Misión</h2>
            <p>Entregar las herramientas y conocimientos de fabricación digital a toda persona que busque aprender y desarrollar innovación de base científico-tecnológica.</p>
          </Col>

          <Col xs={12} md={6}>
            <h2 className="fablab-subtitle">Visión</h2>
            <p>Ser un espacio abierto, inclusivo, respetuoso y seguro donde no existan barreras entre las ideas y la creación.</p>
          </Col>
        </Row>
      </Container>
    )
}